/**
 * Host Feature Types
 */

export interface HostProfile {
  id: string;
  user_id: string;
  nome_display: string;
  ruolo: 'Host' | 'Proprietario' | 'Property Manager' | 'Responsabile Operativo';
  bio?: string;
  avatar?: string;
  paese?: string;
  regione?: string;
  lingue?: string[];
  interessi?: string[];
  tempo_risposta?: string;
  verificato: boolean;
  strutture_nomi?: string[];
  created_at: string;
  updated_at: string;
}

export interface HostProfileInsert {
  nome_display: string;
  ruolo: HostProfile['ruolo'];
  bio?: string;
  avatar?: string;
  paese?: string;
  regione?: string;
  lingue?: string[];
  interessi?: string[];
  tempo_risposta?: string;
  verificato?: boolean;
  strutture_nomi?: string[];
}

export interface HostProfileUpdate extends Partial<HostProfileInsert> {}

export const INTERESSI_MAP: Record<string, string> = {
  "Trekking": "🏔️", "Surf": "🏄", "Ciclismo": "🚵", "Animali": "🐾", "Culture": "🌍",
  "Yoga": "🧘", "Nuoto": "🏊", "Running": "🏃", "Arte": "🎨", "Fotografia": "📷",
  "Chitarra": "🎸", "Puzzle": "🧩", "Musica": "🎵", "Lettura": "📚", "Teatro": "🎭",
  "Vino": "🍷", "Cucina": "🔍", "Street Food": "🍕", "Viaggi": "✈️",
};

export const RUOLI_HOST = [
  "Host",
  "Proprietario", 
  "Property Manager",
  "Responsabile Operativo",
] as const;

export const LINGUE = ["Italiano", "English", "Français", "Deutsch", "Español", "Português", "Русский", "中文", "العربية", "日本語"] as const;

export const TEMPI_RISPOSTA = ["Entro 1 ora", "Entro poche ore", "Entro 24 ore", "Entro 2 giorni"] as const;

export const PAESI = [
  "Italia", "Albania", "Algeria", "Argentina", "Australia", "Austria", "Belgio", "Brasile",
  "Canada", "Cina", "Colombia", "Croazia", "Danimarca", "Egitto", "Emirati Arabi Uniti",
  "Filippine", "Finlandia", "Francia", "Germania", "Giappone", "Grecia", "India", "Irlanda",
  "Israele", "Marocco", "Messico", "Norvegia", "Paesi Bassi", "Polonia", "Portogallo",
  "Regno Unito", "Romania", "Russia", "Slovacchia", "Slovenia", "Spagna", "Svezia",
  "Svizzera", "Tunisia", "Turchia", "Ucraina", "Ungheria", "USA", "Altro",
] as const;

export const REGIONI_ITALIA = [
  "Abruzzo", "Basilicata", "Calabria", "Campania", "Emilia-Romagna", "Friuli-Venezia Giulia",
  "Lazio", "Liguria", "Lombardia", "Marche", "Molise", "Piemonte", "Puglia", "Sardegna",
  "Sicilia", "Toscana", "Trentino-Alto Adige", "Umbria", "Valle d'Aosta", "Veneto",
] as const;

export const INTERESSI_CATEGORIE = [
  { label: "NATURA E AVVENTURA", emoji: "🌿", voci: [{ emoji: "🏔️", nome: "Trekking" }, { emoji: "🏄", nome: "Surf" }, { emoji: "🚵", nome: "Ciclismo" }, { emoji: "🐾", nome: "Animali" }, { emoji: "🌍", nome: "Culture" }] },
  { label: "SPORT E BENESSERE", emoji: "💪", voci: [{ emoji: "🧘", nome: "Yoga" }, { emoji: "🏊", nome: "Nuoto" }, { emoji: "🏃", nome: "Running" }] },
  { label: "ARTE E CREATIVITÀ", emoji: "🎨", voci: [{ emoji: "🎨", nome: "Arte" }, { emoji: "📷", nome: "Fotografia" }, { emoji: "🎸", nome: "Chitarra" }, { emoji: "🧩", nome: "Puzzle" }] },
  { label: "CULTURA E INTRATTENIMENTO", emoji: "🎭", voci: [{ emoji: "🎵", nome: "Musica" }, { emoji: "📚", nome: "Lettura" }, { emoji: "🎭", nome: "Teatro" }, { emoji: "🍷", nome: "Vino" }] },
  { label: "CIBO E STILE DI VITA", emoji: "🔍", voci: [{ emoji: "🔍", nome: "Cucina" }, { emoji: "🍕", nome: "Street Food" }] },
  { label: "VIAGGI ED ESPLORAZIONI", emoji: "✈️", voci: [{ emoji: "✈️", nome: "Viaggi" }] },
] as const;
